import "bootstrap/js/src/tab";
import AOS from "aos";

import "./topbar";
import "../styles/index.scss";

AOS.init();
